document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-cart-drawer]');
  const openCart = () => {
    if (!drawer) return;
    drawer.setAttribute('data-open', '');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
  };
  const closeCart = () => {
    if (!drawer) return;
    drawer.removeAttribute('data-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  };

  document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', openCart));
  document.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', closeCart));

  document.querySelectorAll('[data-menu-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const drawer = document.querySelector('[data-mobile-drawer]');
      const open = drawer.toggleAttribute('data-open');
      toggle.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('drawer-open', open);
    });
  });

  document.querySelectorAll('[data-quantity]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const step = button.dataset.quantityChange === 'plus' ? 1 : -1;
        input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  document.querySelectorAll('[data-quick-add]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      if (button) button.disabled = true;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(form.elements.id.value), quantity: 1 })
        });
        if (!response.ok) throw new Error('Unable to add item');
        const cart = await fetch('/cart.js').then((result) => result.json());
        document.querySelectorAll('.cart-count').forEach((count) => { count.textContent = cart.item_count; });
        const message = document.querySelector('[data-cart-message]');
        if (message) {
          message.classList.add('show');
          window.setTimeout(() => message.classList.remove('show'), 1800);
        }
        window.setTimeout(() => window.location.assign('/cart'), 450);
      } catch (error) {
        window.location.assign(form.action);
      } finally {
        if (button) button.disabled = false;
      }
    });
  });
});
